import { render, staticRenderFns } from "./MailEventDetailModal.vue?vue&type=template&id=13844bfc&scoped=true"
import script from "./MailEventDetailModal.vue?vue&type=script&lang=js"
export * from "./MailEventDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MailEventDetailModal.vue?vue&type=style&index=0&id=13844bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13844bfc",
  null
  
)

export default component.exports